import React from "react";
import { Modal, Form, Select, Button, Radio } from "antd";

const { Option } = Select;

const CoverPageModal = ({
  isCoverPageModalVisible,
  setIsCoverPageModalVisible,
  categories,
  onFinish, // renamed prop here
}) => {
  const [form] = Form.useForm();

  const handleFinish = (values) => {
    onFinish(values);
  };

  return (
    <Modal
      title="Get Cover Page"
      visible={isCoverPageModalVisible}
      onCancel={() => setIsCoverPageModalVisible(false)}
      footer={null}
    >
      <Form
        form={form}
        layout="vertical"
        name="cover_page_form"
        onFinish={handleFinish}
        initialValues={{ exportType: "pdf" }}
      >
        <Form.Item
          name="category"
          label="Category"
          rules={[{ required: true, message: "Please select a category" }]}
        >
          <Select placeholder="Select a category">
            {categories.map((category) => (
              <Option key={category.categoryCode} value={category.categoryCode}>
                {category.categoryName}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="exportType"
          label="Export Type"
          rules={[{ required: true, message: "Please select an export type" }]}
        >
          <Radio.Group>
            <Radio value="pdf">PDF</Radio>
            <Radio value="word">Word</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CoverPageModal;
